const buildImageUrl = function (originalSrc = "", imageWidth = 1200) {
  const cdnBase = "https://aqi.cms-content.com/";
  let folderStructure = originalSrc.replace(cdnBase, "");
  const newUrl = `https://img.imageboss.me/aqi-cmscontent/width/${imageWidth}/quality:100/${folderStructure}`;
  return newUrl;
};

export default buildImageUrl;
